import { lazyValue, noop } from '@proc7ts/primitives';
import { AbortedZExecutionError } from './aborted-execution-error.js';
import { execZ } from './exec.js';
/**
 * Spawns worker thread.
 *
 * @param spawn - Starter function returning started worker instance.
 * @param config - Spawned worker thread configuration.
 *
 * @returns New worker thread execution instance stopping the thread on abort.
 */
export function spawnZWorker(spawn, config = {}) {
    const { stop } = config;
    const stopWorker = stop ? stop.bind(config) : (worker) => worker.terminate();
    return execZ(() => {
        let abort;
        let start;
        let dontStart;
        const whenStarted = new Promise((resolve, reject) => {
            start = resolve;
            dontStart = reject;
        });
        let whenDone = () => new Promise((resolve, reject) => {
            const worker = spawn();
            abort = () => {
                stopWorker(worker);
            };
            const reportError = (error) => {
                abort = noop;
                dontStart(error);
                reject(error);
            };
            worker.on('online', start);
            worker.on('error', reportError);
            worker.on('exit', code => {
                if (code) {
                    reportError(new AbortedZExecutionError(code));
                }
                else {
                    abort = noop;
                    resolve();
                }
            });
        });
        abort = () => {
            whenDone = lazyValue(() => Promise.reject(new AbortedZExecutionError()));
        };
        return {
            whenStarted() {
                return whenStarted;
            },
            whenDone() {
                return whenDone();
            },
            abort() {
                abort();
            },
        };
    });
}
//# sourceMappingURL=spawn-worker.js.map